import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Button, Col, Label, Row } from "reactstrap";
import { AvInput, AvField, AvForm, AvGroup } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

import {
    getDeliveryPartners,
    getRestaurantDeliveryPartnerSettings,
    saveRestaurantDeliveryPartnerSettings,
    resetRestaurantDeliveryPartnerSettings, invalidFormMessage
} from "../../../../actions";
import CommonModal from '../../../common/CommonModal';

class DeliveryProviderSettingsScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            settings: {},
            fields: {},
            type: {
                id: '',
                value: '',
                template: ''
            },
            toSave: false,
            toReset: false,
            openWarningModal: false
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {

        this.props.onRef(this);
        this.props.getDeliveryPartners();
        if (this.props.restaurantId) {
            this.props.getRestaurantDeliveryPartnerSettings(this.props.restaurantId);
        }
    }

    componentWillUnmount() {

        this.props.onRef(undefined);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.restaurantId !== this.props.restaurantId) {
            this.props.getRestaurantDeliveryPartnerSettings(this.props.restaurantId);
        }

        if (this.props.deliveryProvider.restaurantDeliveryPartner &&
            prevProps.deliveryProvider.restaurantDeliveryPartner !== this.props.deliveryProvider.restaurantDeliveryPartner) {
            this.addSettingsToState(this.props.deliveryProvider.restaurantDeliveryPartner,
                () => {
                    this.addFieldsToState(this.props.deliveryProvider.restaurantDeliveryPartner.type.template, true)
                });
        }
    }

    saveNewPartner = (e) => {
        e.preventDefault();
        console.log('SAVE NEW PARTNER')
        let data = {
            settings: JSON.stringify(this.state.fields),
            type: {
                id: this.state.type.id
            }
        };
        this.props.saveRestaurantDeliveryPartnerSettings(this.props.restaurantId, data);
        this.setState({
            ...this.state,
            toSave: false,
            toReset: false
        });
    };

    saveDeliveryPartnerSettings() {

        if (this.state.toSave) {
            document.getElementById("deliveryPartnerFormSubmitBtn").click();
            for (let [key, value] of Object.entries(this.state.fields)) {
                if (value === '') {
                    this.handleInvalidSubmit();
                    this.setState({
                        ...this.state,
                        toSave: true,
                        toReset: false
                    });
                    break;
                }
            }
        } else if (this.state.toReset) {
            this.props.resetRestaurantDeliveryPartnerSettings(this.props.restaurantId);
            this.setState({
                ...this.state,
                toSave: false,
                toReset: false
            });
        }
    };

    handleInvalidSubmit = () => {
        this.props.invalidFormMessage();
    };

    getFieldsFromString(stringOfFields) {
        return stringOfFields.replace(/"/g, "").replace(/\[/g, "").replace(/]/g, "").replace(/ /g, "");
    }

    addSettingsToState = (restaurantDeliveryPartner, callback) => {
        this.setState({
            ...this.state,
            type: restaurantDeliveryPartner.type,
            settings: JSON.parse(restaurantDeliveryPartner.settings)
        }, callback);
    };

    addFieldsToState = (template, componentDidMount, openWarningModal) => {
        let fieldsWithValue = {};
        this.getFieldsFromString(template).split(",").map((field) => {
            fieldsWithValue = { ...fieldsWithValue, [field]: componentDidMount ? this.state.settings[field] : '' };
        });

        this.setState({
            ...this.state,
            fields: fieldsWithValue,
            toSave: !componentDidMount,
            toReset: false,
            openWarningModal: openWarningModal
        });
    };

    toggleModal() {
        this.setState({
            ...this.state,
            openWarningModal: !this.state.openWarningModal
        });
    }

    resetDeliverySettings = () => {
        this.clearPartnerSelection();
    };

    renderResetButton() {
        return (
            <Button style={{ marginTop: 9 }} color="primary" onClick={this.resetDeliverySettings}>
                {i18n.t('common:buttons.reset')}
            </Button>
        );
    };

    renderSaveReminder() {
        const { reminderText } = styles;
        return (
            <p style={reminderText}>{i18n.t('common:validations.saveWarningMsg')}</p>
        );
    }


    renderDeliveryPartnerSelect() {
        const { fieldContainer, inputGroupStyle, labelStyle, inputStyle } = styles;

        return (
            <div style={fieldContainer}>
                <AvGroup style={inputGroupStyle}>
                    <Label style={labelStyle}>{i18n.t('screens:deliveryPartnerScreen.partner')}</Label>
                    <AvGroup style={inputStyle}>
                        <AvField type="select" name="id" id="deliveryPartner"
                            value={this.state.type.id}
                            onChange={this.selectDeliveryPartner}
                        >
                            <option disabled value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                            {this.props.deliveryProvider.deliveryPartners.map((item, i) => {
                                return (<option value={item.id} id={item.id} key={i}>{item.value}</option>)
                            })}
                        </AvField>
                    </AvGroup>
                </AvGroup>
                {this.renderResetButton()}
                {this.state.toSave || this.state.toReset ? this.renderSaveReminder() : null}
                <div style={{ margin: '18px 0px 0px 40px' }}>
                    <label for='useGeneralDeliveryPartnerSettings'>{i18n.t('screens:deliveryPartnerScreen.useForAllZones')}</label>
                    <input type="checkbox" name='useGeneralDeliveryPartnerSettings' id='useGeneralDeliveryPartnerSettings' style={styles.checkboxInput}
                        checked={this.props.partnerCheckboxValue}
                        onChange={this.props.onChangePartnerCheckbox} />
                </div>
            </div>
        )
    }

    clearPartnerSelection() {
        this.setState({
            ...this.state,
            settings: {},
            fields: {},
            type: {
                id: '',
                value: '',
                template: ''
            },
            toSave: false,
            toReset: true

        });
    }

    selectDeliveryPartner = ({ target }) => {
        for (let i = 0; i < this.props.deliveryProvider.deliveryPartners.length; i++) {

            let deliveryPartner = this.props.deliveryProvider.deliveryPartners[i];

            if (deliveryPartner.id === Number(target.value)) {
                this.setState({
                    ...this.state,
                    settings: {},
                    fields: {},
                    type: deliveryPartner
                }, () => {
                    let isStuartMsgOpen = false;
                    if (deliveryPartner.id === 2) {
                        isStuartMsgOpen = true;
                    }
                    this.addFieldsToState(deliveryPartner.template, false, isStuartMsgOpen);
                });
                break;
            }
        }
    };

    updateFieldValue = ({ target }) => {
        this.setState({
            ...this.state,
            toSave: true,
            fields: {
                ...this.state.fields,
                [target.name]: target.value
            }
        });
    };

    renderDeliveryPartnerFields() {
        const { inputGroupStyle, labelStyle, inputStyle, fieldContainer } = styles;

        return (
            <Fragment>
                <div style={fieldContainer}>
                    {Object.keys(this.state.fields).map((key) => {
                        return (
                            <AvGroup style={inputGroupStyle}>
                                <Label style={labelStyle}>{i18n.t(`screens:deliveryPartnerScreen.fields.${key}`)}</Label>
                                <AvInput style={inputStyle}
                                    type={key === 'password' ? 'password' : 'text'} name={key}
                                    value={this.state.fields[key]}
                                    onChange={this.updateFieldValue}
                                    errorMessage={i18n.t('common:validations.errorMsg')}
                                    required>
                                </AvInput>
                            </AvGroup>
                        )
                    })}
                </div>
            </Fragment>
        );
    }

    render() {
        const { headerStyle, headerTitle, hint } = styles;

        return (
            <Fragment>
                <Col className="sectionStyle">
                    <Row>
                        <div style={headerStyle}>
                            <MaterialIcon icon="motorcycle" size={20} color='#0288d1' />
                            <span style={headerTitle}>{i18n.t('screens:deliveryPartnerScreen.heading')}</span>
                        </div>
                    </Row>
                    <Row>
                        <AvForm onValidSubmit={this.saveNewPartner} style={{ width: '100%' }}>
                            {this.renderDeliveryPartnerSelect()}
                            {this.renderDeliveryPartnerFields()}
                            <p style={hint}>{i18n.t(`screens:deliveryPartnerScreen.hint`)}</p>
                            <button style={{ display: 'none' }} type="submit" id="deliveryPartnerFormSubmitBtn" />
                        </AvForm>
                    </Row>
                </Col>
                {
                    this.state.openWarningModal && <CommonModal
                        useCase={'providerMessage'}
                        isOpen={this.state.openWarningModal}
                        onToggle={this.toggleModal}
                    >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <h6>{i18n.t('screens:deliveryPartnerScreen.stuartWarning')}</h6>
                        </div>
                    </CommonModal>
                }
            </Fragment >
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurantId: state.restaurant.id,
        deliveryProvider: state.deliveryProvider
    }
};

export default connect(mapStateToProps, {
    getDeliveryPartners,
    getRestaurantDeliveryPartnerSettings,
    saveRestaurantDeliveryPartnerSettings,
    resetRestaurantDeliveryPartnerSettings,
    invalidFormMessage
})(DeliveryProviderSettingsScreen);

const styles = {
    headerStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        width: 299
    },
    headerTitle: {
        paddingLeft: 4,
        color: '#0288d1'
    },
    inputGroupStyle: {
        width: '50%',
        padding: "10px 20px 0 20px",
        display: 'flex',
        justifyContent: 'space-between'
    },
    labelStyle: {
        width: '30%',
        paddingTop: 10
    },
    inputStyle: {
        width: '60%'
    },
    fieldContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    hint: {
        fontSize: 14
    },
    reminderText: {
        color: '#dc3545',
        fontSize: 13,
        position: 'absolute',
        right: 20,
        paddingTop: 20
    },
    checkboxInput: {
        position: "relative",
        marginLeft: 10,
        marginTop: 6
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/DeliveryProviderSettingsScreen.js